// extracted by mini-css-extract-plugin
export var actionIcon = "_vb-0";